import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-documents', en)

export * from './src/pages/default'
export * from './src/pages/statements'
export * from './src/pages/statements-date'
export * from './src/pages/taxes-date'
export * from './src/pages/legal-partner'
export * from './src/pages/trade-confirmations'
export * from './src/constants'
